<template>
    <div class="tower-view">
        <div class="inner">
            <img
                class="bg"
                :src="
                    require(`@/assets/Stage/Tower/${type}/Level${level}/bg.png`)
                "
                alt=""
                width="100%"
            />
            <!-- <img
                class="bg mask"
                src="@/assets/Stage/Tower/mask.png"
                alt=""
                width="100%"
            /> -->
            <TowerItem
                v-for="item in itemAmount"
                :key="`tower-item${item}`"
                :index="item"
                :unlocked="unlockList[item]"
                :cursor="cursor"
                :base-cycle="baseCycle"
            />
        </div>
        <TowerNoLoggedInView v-if="!user" />
    </div>
</template>

<script>
import { mapState } from 'vuex';

import TowerItem from '@/components/Stage/Tower/TowerItem.vue';
import TowerNoLoggedInView from '@/components/Stage/Tower/TowerNoLoggedInView.vue';

const CONFIG = {
    game1: {
        level1: {
            itemAmount: 7,
            baseCycle: 1,
        },
        level2: {
            itemAmount: 7,
            baseCycle: 2,
        },
        level3: {
            itemAmount: 7,
            baseCycle: 3,
        },
    },
    game2: {
        level1: {
            itemAmount: 7,
            baseCycle: 1,
        },
        level2: {
            itemAmount: 7,
            baseCycle: 2,
        },
        level3: {
            itemAmount: 7,
            baseCycle: 3,
        },
    },
};

export default {
    components: { TowerItem, TowerNoLoggedInView },
    data() {
        return {
            itemAmount: 0,
            baseCycle: 0,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.user,
            towerUnlocked: (state) => state.towerUnlocked,
        }),
        type() {
            return (
                this.$route.params.type.charAt(0).toUpperCase()
                + this.$route.params.type.slice(1)
            );
        },
        level() {
            return (
                this.$route.params.level.charAt(0).toUpperCase()
                + this.$route.params.level.slice(1)
            );
        },
        unlockList() {
            if (this.towerUnlocked?.game1) {
                const LIST = [];
                for (let i = 0; i < this.itemAmount; i += 1) {
                    const THRESHOLD = this.towerUnlocked[this.$route.params.type][
                        `level${this.$route.params.level}`
                    ];
                    LIST.push(i <= THRESHOLD);
                }
                return LIST;
            }
            return [];
        },
        cursor() {
            if (this.towerUnlocked?.game1) {
                let CURSOR = 0;
                for (let i = 0; i < this.itemAmount; i += 1) {
                    const THRESHOLD = this.towerUnlocked[this.$route.params.type][
                        `level${this.$route.params.level}`
                    ];
                    if (i < THRESHOLD) CURSOR += 1;
                }
                return CURSOR;
            }
            return 0;
        },
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.itemAmount = CONFIG[this.$route.params.type][
                `level${this.$route.params.level}`
            ].itemAmount;
            this.baseCycle = CONFIG[this.$route.params.type][
                `level${this.$route.params.level}`
            ].baseCycle;
        },
    },
};
</script>

<style lang="scss" scoped>
.tower-view {
    position: relative;
    width: 100%;
    height: 100%;
    flex: 1;
    overflow: hidden;
    display: flex;
    justify-content: flex-end;
    .inner {
        overflow: auto;
        position: relative;
        display: flex;
        flex-direction: column-reverse;
        width: 100%;
        > * {
            position: relative;
            &:last-child {
                margin-top: 6em;
            }
        }
    }
    .bg {
        position: absolute;
        bottom: 0;
        display: block;
        // &.mask {}
    }
    .toggle {
        z-index: 1;
        cursor: pointer;
        font-size: 30px;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
